import * as React from 'react';

export interface IErrorMessageStyleleProps {
  message?: React.ReactNode;
}

export default function ErrorMessageStyle(props: IErrorMessageStyleleProps) {
  const { message } = props;
  return (
    <p className="text-red-dark whitespace-pre-line font-normal text-xs bg-red-100 rounded-lg w-full p-1 mt-2 capitalize pl-4">
      {message}
    </p>
  );
}
